"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var OrderStatus;
(function (OrderStatus) {
    OrderStatus[OrderStatus["PENDING"] = 0] = "PENDING";
    OrderStatus[OrderStatus["PAID"] = 1] = "PAID";
    OrderStatus[OrderStatus["FULLFILLED"] = 2] = "FULLFILLED";
    OrderStatus[OrderStatus["CANCELED"] = 3] = "CANCELED";
    OrderStatus[OrderStatus["REFUNDED"] = 4] = "REFUNDED";
})(OrderStatus = exports.OrderStatus || (exports.OrderStatus = {}));
var OrderPayScheduleStatus;
(function (OrderPayScheduleStatus) {
    OrderPayScheduleStatus[OrderPayScheduleStatus["NEW"] = 0] = "NEW";
    OrderPayScheduleStatus[OrderPayScheduleStatus["PENDING"] = 1] = "PENDING";
    OrderPayScheduleStatus[OrderPayScheduleStatus["PAID"] = 2] = "PAID";
})(OrderPayScheduleStatus = exports.OrderPayScheduleStatus || (exports.OrderPayScheduleStatus = {}));
// 付费用户
var IsPay;
(function (IsPay) {
    IsPay[IsPay["PAY"] = 0] = "PAY";
    IsPay[IsPay["NOT_PAY"] = 1] = "NOT_PAY";
})(IsPay = exports.IsPay || (exports.IsPay = {}));
var PayWay;
(function (PayWay) {
    PayWay[PayWay["NORMAL"] = 0] = "NORMAL";
    PayWay[PayWay["OLD_NORMAL"] = 1] = "OLD_NORMAL";
    PayWay[PayWay["COUPON"] = 2] = "COUPON";
    PayWay[PayWay["PREORDER"] = 3] = "PREORDER";
    PayWay[PayWay["PREORDER_REMAIN"] = 4] = "PREORDER_REMAIN";
    PayWay[PayWay["LIMIT"] = 5] = "LIMIT";
    PayWay[PayWay["RESERVATION"] = 6] = "RESERVATION";
})(PayWay = exports.PayWay || (exports.PayWay = {}));
var DepositPaymentStatus;
(function (DepositPaymentStatus) {
    DepositPaymentStatus[DepositPaymentStatus["UNPAID"] = 0] = "UNPAID";
    DepositPaymentStatus[DepositPaymentStatus["PAID"] = 1] = "PAID";
})(DepositPaymentStatus = exports.DepositPaymentStatus || (exports.DepositPaymentStatus = {}));
var BuyTextStyle;
(function (BuyTextStyle) {
    BuyTextStyle[BuyTextStyle["FREE_COLLECTION"] = 0] = "FREE_COLLECTION";
    BuyTextStyle[BuyTextStyle["PRICE_AND_SIGN_UP"] = 1] = "PRICE_AND_SIGN_UP";
    BuyTextStyle[BuyTextStyle["PRICE_AND_ORIGINAL_PRICE_AND_SIGN_UP"] = 2] = "PRICE_AND_ORIGINAL_PRICE_AND_SIGN_UP";
    BuyTextStyle[BuyTextStyle["SURPLUS_QUOTA_AND_SIGN_UP"] = 3] = "SURPLUS_QUOTA_AND_SIGN_UP";
})(BuyTextStyle = exports.BuyTextStyle || (exports.BuyTextStyle = {}));
var PurchaseMethod;
(function (PurchaseMethod) {
    PurchaseMethod[PurchaseMethod["DIRECT"] = 0] = "DIRECT";
    PurchaseMethod[PurchaseMethod["FREE"] = 1] = "FREE";
    PurchaseMethod[PurchaseMethod["JOIN_GROUPON"] = 2] = "JOIN_GROUPON";
    PurchaseMethod[PurchaseMethod["CREATE_GROUPON"] = 3] = "CREATE_GROUPON";
})(PurchaseMethod = exports.PurchaseMethod || (exports.PurchaseMethod = {}));
var AlipaySuccessCode;
(function (AlipaySuccessCode) {
    AlipaySuccessCode["PAYMENT_SUCESS_CODE"] = "9000";
    AlipaySuccessCode["PAYMENT_FAIL_CODE"] = "4000";
    AlipaySuccessCode["PAYMENT_CANCEL_CODE"] = "6001";
})(AlipaySuccessCode = exports.AlipaySuccessCode || (exports.AlipaySuccessCode = {}));
//# sourceMappingURL=order.js.map


//////////////////
// WEBPACK FOOTER
// ../core/dist/src/types/order.js
// module id = 997
// module chunks = 0